import { Text } from '@/components/Atoms/Text/Text';
import { FOOTER_LINK_TYPES } from '@/components/AuthV2/InfoGraphics';

import { FooterSection } from './FooterSection';

export const Footer = () => {
  return (
    <div className='absolute bottom-0 left-0 flex w-full justify-between items-center p-6'>
      <FooterSection type={FOOTER_LINK_TYPES.SECURITY} />
      <div className='flex flex-col'>
        <Text bold>Our Companion App is available on</Text>
        <FooterSection type={FOOTER_LINK_TYPES.APP_STORE} />
      </div>
    </div>
  );
};
